// Module
var code = "<find-user-by-code></find-user-by-code> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/Dashboard/FindUserByCode/FindUserByCode.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;